import { useRouter } from 'next/router';
import { Alert, Box } from '@mui/material';
// Components
import { AlertBody, LoadingBox } from '@/common/index';
import { ProductCard, SearchError, CreditBanner } from './components';
import { StoreLayout } from './StoreLayout';
// Hooks
import { useAuth } from '@/hooks/useAuth';
import { useStoreContext } from '@/providers/StoreProvider';
import { useCheckoutContext } from '@/providers/CheckoutProvider';
import { useWallet } from '@/hooks/useWallet';

export default function Store() {
  const router = useRouter();
  const { filter } = router.query; // URL path for category
  const { memberData } = useAuth();
  const {
    filteredProducts,
    resetSearch,
    search,
    searchError,
    storeError,
    storeItems,
    storeLoading,
    view,
  } = useStoreContext();
  const { couponState } = useCheckoutContext();
  const canPurchaseNodes = memberData?.canPurchaseNodes;
  const { coreWalletCoinState: hasWallet, walletCoinState } = useWallet();

  const productsList = filteredProducts.length ? filteredProducts : storeItems;

  if (storeLoading) {
    return <LoadingBox />;
  }

  if (storeError.error) {
    return (
      <Alert severity="error" variant="outlined">
        <AlertBody
          header="Server Error."
          body="Products are unable to load at this time. Please refresh the page or try again
            later."
        />
      </Alert>
    );
  } else if (!storeItems.length) {
    return (
      <Alert severity="info" variant="outlined">
        <AlertBody
          header="We don't have any products set up right now."
          body="Please try again later."
        />
      </Alert>
    );
  }

  return (
    <Box display={'flex'} flexDirection={'column'}>
      <Box width={'100%'}>
        {searchError ? (
          <SearchError search={search} resetSearch={resetSearch} />
        ) : (
          <>
            {couponState.showBanner && <CreditBanner />}
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns:
                  view === 'grid' ? 'repeat(auto-fill, minmax(250px, 1fr))' : '1fr',
                gap: '24px',
              }}
            >
              {productsList?.map((product) => (
                <ProductCard
                  layout={view}
                  key={product.id}
                  filter={filter}
                  product={product}
                  canPurchaseNodes={canPurchaseNodes}
                  hasWallet={hasWallet}
                  hasLegacyWallet={walletCoinState.hasWallet}
                />
              ))}
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
}

Store.getLayout = (page) => (
  <StoreLayout filterOpen={page.filterOpen}>{page}</StoreLayout>
);
